import React, { useState } from 'react';
import { get } from 'lodash';
import { asField } from 'informed';
import Select from 'react-select';
import { FormGroup } from 'reactstrap';
import classnames from 'classnames';
import { useEffect } from 'react';

const InputSelectMulti = asField(({ field, fieldState, fieldApi, ...props }) => {
  const { value } = fieldState;
  const { setValue } = fieldApi;
  const {
    col,
    label,
    onChange,
    onFocus,
    multi,
    required,
    selectAll,
    options = [],
    disabled,
    selected = {},
    marginBottom,
    width,
    widthSelect,
    marginLeftSelect,
    marginTop,
    onInputChange,
    styleAtividade,
    ...rest
  } = props;

  const error = get(fieldState, 'error', []);
  const hasError = Array.isArray(error) && error.length > 0;
  const [click,setClick] = useState()
  const [habilidade,setHabilidade] = useState()
  const [newValue,setNewValue] = useState([])

  const modifiedValue = (value) => {
    if(value){
       const novo = value.map(value => ({
        codigo: value.codigo,
        label: value.codigo,
        value: value.value
      })) 
    setNewValue(novo)
    } 
  }

  useEffect(() => {
    if (newValue) {
      setValue(newValue.map((x) => x.value));
    } else {
      setValue([]);
    }
  }, [newValue])

  useEffect(() => {
    if (click){
      if(habilidade){
        modifiedValue(habilidade)
        setClick(false);
      }
    }
  },[click])
  
  return (
    <FormGroup
      style={{ color: '#453166', marginBottom: marginBottom, marginTop: marginTop, width: width }}
      className={classnames(col, { required, 'has-error': hasError })}
    >
      {label && (
        <label
          style={ {
            fontFamily: 'Public Sans',
            fontSize: '14px',
            fontWeight: 500,
            lineHeight: '16px',
            letterSpacing: '0em',
            textAlign: 'left',
            color: '#4A4F58'
          }}
          className={classnames({ 'text-danger': hasError })}
        >
          {label}
        </label>
      )}
      <Select
        style={{ width: widthSelect,marginLeft: marginLeftSelect}}
          
          onChange={(value) => {
            setClick(true)
            setHabilidade(value)

            fieldApi.setError(null);
            fieldApi.setTouched();
  
            if (onChange) onChange(newValue);
          }}
          onFocus={(value) => {
            if (onFocus) onFocus(value);
          }}
          onInputChange={(value) => {
            if (onInputChange) onInputChange(value);
          }}
         
          value={newValue}
          noResultsText="Nenhum resultado encontrado."
          placeholder={'Selecione'}
          multi={multi}
          options={options} 
          disabled={disabled}
          {...rest}
      />
    
      {error.map((e) => (
        <p key={e} className="text-danger">
          {e}
        </p>
      ))}
    </FormGroup>
  );
});

InputSelectMulti.defaultProps = {
  placeholder: 'Selecione',
  loadingMessage: () => 'Carregando...',
  marginBottom: "1rem",
  marginTop: ""
};

export default InputSelectMulti;
